import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

async function updateProductLots(data) {
  const res = await http(`/admin/product-lots-qnt`, {
    method: "PATCH",
    data: data,
  });
  return res;
}

export function useUpdateProductLots() {
  const queryClient = useQueryClient();

  return useMutation(updateProductLots, {
    onSuccess: async (res) => {
      if (res?.status === 201 || res?.status === 200) {
        await queryClient.invalidateQueries(["product-stock-histories"]);
        await queryClient.invalidateQueries(["product-lots"]);
        await queryClient.invalidateQueries([
          "product-stock-histories-summary",
        ]);
        await queryClient.invalidateQueries(["product-lots-qnt"]);
      }
    },
  });
}
